const PoisonQueuePhotoDisplay = ({ photoUri }: { photoUri?: string }) => {
  if (!photoUri) return null;

  return <img src={photoUri} width={'40px'} height={'40px'} />;
};

export default PoisonQueuePhotoDisplay;
